		
<template>
	<div class="ad-label d-flex justify-content-center align-items-center" style="position:absolute;z-index:1;">
		<div>
			¡Oferta de lanzamiento! <br><span>New Price</span> <br>Precio original: <span class="crossed">Old Price</span>
		</div>
	</div>

</template>

<script>

export default {
	name: "AdSection",
}
</script>

<style scoped>
	.ad-label {
		position: absolute;
		right:0vw;
		width: 16em;
		height: 8em;
		font-size: 20px;
		font-weight: bolder;
		border-radius: 50%;
		background-color: red;
		color: turquoise;
		text-align: center;
		-webkit-transform-origin-x: 10em;
		-webkit-transform-origin-y: -2em;
		transform: rotateZ(-13deg);
		padding: 0.5em;
	}
	
	@media only screen and (max-device-width: 768px) {
		.ad-label {
			right:15vw;
		}
	}
	.ad-label span{
		font-size:22px;
		display: inline-block;
	}
		
	@media only screen and (max-device-width: 480px) {
		.ad-label {
			font-size: 10px;
			height: 10em;
			right: 8vw;
			width: 20em;
			top: -2.5em;
		}
		.ad-label span {
			font-size: 18px;
		}
	}

	.crossed {
		position: relative;
		display: inline-block;
	}
	.crossed::before, .crossed::after {
		content: '';
		width: 100%;
		position: absolute;
		right: 0;
		top: 50%;
	}
	.crossed::before {
		border-bottom: 2px solid #41E0D0;
		-webkit-transform: skewY(-10deg);
		transform: skewY(-10deg);
	}
	.crossed::after {
		border-bottom: 2px solid #41E0D0;
		-webkit-transform: skewY(10deg);
		transform: skewY(10deg);
	}

</style>